import { darkPalette, primaryColor } from "../palette";
export const MuiPickersClockNumber = {
  MuiPickersClockNumber: {
    clockNumber: {
      color: "inherit",
    },
  },
};
